import { XHRAction, XHRClient } from 'mk2/helpers/api';
import { Action, Dispatch, Middleware, MiddlewareAPI } from 'redux';

/**
 * Inject xhr client API to all actions
 */
export function createXhrMiddleware(xhr: XHRClient): Middleware {
    return <S>(api: MiddlewareAPI<S>) =>
        (next: Dispatch<S>) =>
            <A extends Action>(action: A & XHRAction): A & XHRAction => {
                action.xhr = xhr;
                return next(action);
            };
}
